import { render } from "./Apple.vue?vue&type=template&id=520b000c&scoped=true"
import script from "./Apple.vue?vue&type=script&lang=js"
export * from "./Apple.vue?vue&type=script&lang=js"

import "./Apple.vue?vue&type=style&index=0&id=520b000c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520b000c"]])

export default __exports__